<template>
	<div id="indexpage" class=""> 
		<div class="indexcenterpage">
		<leftnav class="fl" openmeunclass='cyyj' :curindex="2" :title="title"></leftnav> 
		<!-- <span   @click="isCollapse = !isCollapse"  v-html="isCollapse?'>':'<'" class="nav_btn"> 展开</span> -->
		<div :class="userdata.userType ==1?'index_left':''"> 
		<govheader v-if="userdata.userType==1"></govheader>
		<div class="index_left_centerpage" > 
		<div class="index_block whitebox ">
				<div class="block_title oh">
					<h3 class="title fl">{{userdata.cityText}}本地图谱</h3>
					<!-- <span class="chain-more fr" @click="routerblank('/allchain')">更多</span> -->
				</div>
				<ul class="hotchain-list oh">
					<li v-for="(list,index) in resdata" @click="routerlinkid('/localChain',list.chainId)" class="fl">
						<div class="imgbox"><img :src="list.image" v-bind:alt="list.chainName"></div>
							<h5 class="title">{{list.chainName}}</h5> 
					</li>
				</ul>
		 </div>
			 
 
 
 
	</div> 
	</div> 
	</div>
	<footerbar v-if="userdata.userType>1"></footerbar>
	</div> 	
</template>

<script> 
	export default {
	  name: 'industrial-opportunities',
	 data(){
			return{
				style:{
					width:'90%',
				},
				isCollapse:false,
				title:"产业图谱",
				showmorenode:false,
				userdata:{},  
				resdata:{},
				// chainnodelist:[],
				// hotchainlist:[],
				// recommonchain:[],
				// marketopprlist:[],  
				// landdatalist:[], 
				// investdatalist:[],
				// companylist:[],edition:0,
			}
		}, 
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},
		created() { 
				this.$nextTick(() => {
				        // 禁用右键
				        document.oncontextmenu = new Function("event.returnValue=false");
				        // 禁用选择
				        document.onselectstart = new Function("event.returnValue=false");
				      }); 
			var _this=this; 
			this.userdata = this.getuseriformation();
		},
	 mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
	 	// console.log(this.$route.params.categoryid)
			this.getlist();
	 }, 
		methods:{
			//获取列表内容
			getlist(pages){
				var _this=this;
				this.$axios.get(this.$api.cyl.localchain.list(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
					if(res.data.success){   
						_this.resdata=res.data.list; 
					 
						console.log(_this.resdata); 
						setTimeout(function(){_this.bus.$emit('loading', false);},1200)
					}else{ 
							
					} 
				}).catch(function (error) { 
					// 请求失败处理 console.log(error);
				}); 
			},
		}
	}
</script>

<style>
</style>
